import { Paragraph, ParagraphProps } from 'theme-ui';

export interface CardValueProps extends ParagraphProps {}

const CardValue: React.FC<CardValueProps> = (props) => <Paragraph variant="labelSemibold" {...props} ref={null} />;

export default CardValue;
